import React from "react";
import { Modal, Form, Input, Alert } from "antd";

function PasswordResetModal({ user, onCancel, onSave }) {
  const [form] = Form.useForm();

  const handleOk = async () => {
    const values = await form.validateFields();
    onSave(values.new_password);
  };

  return (
    <Modal
      title={`비밀번호 초기화 — ${user?.name || user?.email || ""}`}
      open
      onOk={handleOk}
      onCancel={onCancel}
      okText="변경"
      cancelText="취소"
      okButtonProps={{ danger: true }}
    >
      <Alert
        type="warning"
        showIcon
        message="이 회원의 비밀번호가 즉시 새 값으로 교체됩니다."
        description="변경한 비밀번호를 회원에게 직접 전달해주세요."
        style={{ marginBottom: 16 }}
      />
      <Form form={form} layout="vertical">
        <Form.Item
          label="새 비밀번호"
          name="new_password"
          rules={[
            { required: true, message: "새 비밀번호를 입력해주세요." },
            { min: 4, message: "최소 4자 이상이어야 합니다." },
          ]}
        >
          <Input.Password placeholder="새 비밀번호" autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          label="새 비밀번호 확인"
          name="confirm"
          dependencies={["new_password"]}
          rules={[
            { required: true, message: "확인을 위해 한 번 더 입력해주세요." },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("비밀번호가 일치하지 않습니다."));
              },
            }),
          ]}
        >
          <Input.Password placeholder="새 비밀번호 확인" autoComplete="new-password" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default PasswordResetModal;
